/**
 * @generated SignedSource<<5199d174c29cd053d90bcc6ae6ea6c8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateReservationInput = {
  assetTags?: ReadonlyArray<any> | null | undefined;
  clientMutationId?: string | null | undefined;
  customerId: string;
  endsAt: any;
  notes?: string | null | undefined;
  startsAt: any;
};
export type OpsReservationNewPageCreateMutation$variables = {
  input: CreateReservationInput;
};
export type OpsReservationNewPageCreateMutation$data = {
  readonly createReservation: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationNewPageCreateMutation = {
  response: OpsReservationNewPageCreateMutation$data;
  variables: OpsReservationNewPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateReservationPayload",
    "kind": "LinkedField",
    "name": "createReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationNewPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationNewPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "34cda4d384ca7cf1b918306f731b390b",
    "id": null,
    "metadata": {},
    "name": "OpsReservationNewPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationNewPageCreateMutation(\n  $input: CreateReservationInput!\n) {\n  createReservation(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67168d41e91a1c56a54b5a08a5716c82";

export default node;
